import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import { IAppVariable } from '../../../../types/interfaces/app-variable';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (property: IAppVariable) => void,
  onDelete: (property: IAppVariable) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.KEY,
      cellReducer: (variable: IAppVariable) => {
        return <div className={classes.key}>{variable.key}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.VALUE,
      cellReducer: (variable: IAppVariable) => {
        return <div className={classes.value}>{variable.value}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.TYPE,
      cellReducer: (variable: IAppVariable) => {
        return <div className={classes.type}>{variable.type}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.IS_PRIVATE,
      cellReducer: (variable: IAppVariable) => {
        return (
          <div className={classes.isPrivate}>
            <Checkbox disabled checked={variable.isPrivate}></Checkbox>
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (variable: IAppVariable) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(variable);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(variable);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
